// import external dependencies
import 'jquery';
import 'ekko-lightbox/dist/ekko-lightbox.js';
import 'slick-carousel';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import { library, dom } from '@fortawesome/fontawesome-svg-core'

// import used icons
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add( faAngleDown);
// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready(function($) {
  $(window).on('scroll load resize', function () {
    $('body').toggleClass('scrolling', ($(window).scrollTop() > 50));
  });

  $(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });

  $('.wp-block-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
  });

  if( $(window).width() > 576 ) {
    $('.site-header').on('click', '.header-quote-basket', function(e) {
      e.preventDefault();
      $('.header-actions').toggleClass('minicart-open');
    })
  }

  $(document).on('input', '.per-product-message',function(){
    if( !$('.addify-quote-form').hasClass('save-notice-active') ) {
      $('.addify-quote-form').addClass('save-notice-active');
      $('.quote-remember-to-update').fadeIn('fast', function(){
        $(this).clone().insertBefore('.addify_checkout_place_quote'); //.fadeIn('fast');
      });
      // $('.quote-remember-to-update').clone().insertBefore('.addify_checkout_place_quote');
      $('.addify_checkout_place_quote').attr('disabled', true);
    }
  });

  $('#afrfq_update_quote_btn').on('click', function(){
    setTimeout(function(){
      $('.addify-quote-form').removeClass('save-notice-active');
      $('.addify_checkout_place_quote').attr('disabled', false);
      $('.af_quote_fields .quote-remember-to-update').fadeOut('fast', function(){
        $(this).remove();
      });
    }, 1000);
  });

  if( $('.product-image-price-tabs').length ) {
    $('.product-image-price-tabs .images').append( $('.product-image-price-tabs .price') );
    $('.product-image-price-tabs .images').append( $('.product-image-price-tabs .product-manufacturer') );
  }

  if( $('.belentia-variation-images').length ) {
    $('.belentia-variation-images').each(function(index, el) {
      var key = $(el).data('key');
      var val = $('select[data-attribute_name="' + key + '"]').val();
      $(el).find('.belentia-single-variation[data-value="' + val + '"]').addClass('active');
    });
  }

  $('.variations select').change(function() {
    var val = $(this).val();
    var key = $(this).data('attribute_name');
    $('.belentia-variation-images[data-key="'+key+'"] span').removeClass('active');

    if( val ) {
      $('.belentia-variation-images[data-key="'+key+'"] span[data-value="' + val + '"]').addClass('active');
    }

    // Update the selected variations info to hidden field
    if( $('.offer-attrs').length ) {
      belentiaBuildVariationsInfo();
    }
  });

  $('.variations .belentia-variation-images span').click(function() {
    if( !$(this).hasClass('active') ) {
      var val = $(this).data('value');
      var key = $(this).parent().data('key');

      $('.belentia-variation-images[data-key="'+key+'"] span').removeClass('active');
      $(this).addClass('active');

      $('.variations select[data-attribute_name="' + key + '"]').val(val).change();
    }
  });

  if( $('.addify-quote-form').length ) {
    $('.addify-option-field').each(function() {
      var input = $(this).find('input');
      var label = $(this).find('th');
      if( $(input).attr('required') ) {
        $(label).html( $(label).text() + ' <span style="color:#C02B0A;">*</span>' );
      }
    });
  }
  
  // svg images to inline SVG
  $('img.svg').each(function(){
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
      // Get the SVG tag, ignore the rest
      var $svg = $(data).find('svg');

      // Add replaced image's ID to the new SVG
      if(typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
      }
      // Add replaced image's classes to the new SVG
      if(typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass+' replaced-svg');
      }

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg = $svg.removeAttr('xmlns:a');

      // Replace image with new SVG
      $img.replaceWith($svg);
    }, 'xml');
  });

  // TODO: maybe later? Open photoswipe for variation images in here
  // examples at woo/assets/js/frontend/single-product.js
  // https://photoswipe.com/documentation/getting-started.html

  $.fn.dropdown = (function() {
    var $bsDropdown = $.fn.dropdown;
    return function(config) {
      if (typeof config === 'string' && config === 'toggle') { // dropdown toggle trigged
        $('.has-child-dropdown-show').removeClass('has-child-dropdown-show');
        $(this).closest('.dropdown').parents('.dropdown').addClass('has-child-dropdown-show');
      }
      var ret = $bsDropdown.call($(this), config);
      $(this).off('click.bs.dropdown'); // Turn off dropdown.js click event, it will call 'this.toggle()' internal
      return ret;
    }
  })();

  $(function() {
    $('.dropdown [data-toggle="dropdown"]').on('click', function(e) {
      $(this).dropdown('toggle');
      e.stopPropagation();
      // Scroll to opened menu item
      document.getElementById( $(this).attr('ID') ).scrollIntoView({behavior: 'smooth'});
    });
    $('.dropdown.mobile-open').on('click', function(e) {
      //e.preventDefault();
      $(this).find('[data-toggle="dropdown"]').dropdown('toggle');
      e.stopPropagation();
      // Scroll to opened menu item
      document.getElementById( $(this).find('[data-toggle="dropdown"]').attr('ID') ).scrollIntoView({behavior: 'smooth'});
    });
    $('.dropdown').on('hide.bs.dropdown', function(e) {
      if ($(this).is('.has-child-dropdown-show')) {
        $(this).removeClass('has-child-dropdown-show');
        e.preventDefault();
      }
      e.stopPropagation();
    });
  });

  function belentiaBuildVariationsInfo() {
    var selection = '';

    $('.belentia-variation-images').each(function(index, el) {
      var val = $(el).find('span.active').data('value');

      if( val != '' ) {
        selection += $(el).data('name') + ': ' + val + ',';
      }
      //console.log(selection);
    });

    $('.offer-attrs input').val( selection.slice(0, -1) );
  }

	// var isChromium = window.chrome;
	// if (isChromium) {
  //   console.log('test: chrome');
	// 	$(window).on('pageshow', function() {
	// 		// if (e.originalEvent.persisted) {
	// 			setTimeout(function() {
	// 				$(document.body).trigger('wc_fragment_refresh');
  //         console.log('test: chrome2');
	// 			}, 300);
	// 		// }
	// 	});
	// }

  /*
   * Jquery Plugin for Finnish Hyphenator
   * Author: Veikko Karsikko
  */

  /* Constructor :: CLASS */
  function FinnishHyphenator() {
    this.vowels = 'aeiouyåäö';
    this.consonants = 'bcdfghjklmnpqrstvwxyz';
    this.hyphMark = '\u00AD';
    // construct regExps only once
    this.rule1RegExp = new RegExp('[' + this.consonants + '][' + this.vowels + ']', 'gi');
    this.endReg = new RegExp('[' + this.consonants + this.vowels + ']{2}$', 'i');
    this.wrapperElement = document.createElement('div');
  }

  /* Adds hyphen to text if first part matches endReg */
  FinnishHyphenator.prototype.addHyphen = function(text, idx) {
    var firstPart = text.slice(0, idx);
    if (this.endReg.exec(firstPart)) {
      return (text.slice(0, idx) + this.hyphMark + text.slice(idx));
    } else {
      return false;
    }
  };

  /* Hyphenates JQuery element contents */
  FinnishHyphenator.prototype.hyphenateElement = function(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3) {
        // is text element and will be hyphenated
        node.data = this.hyphenateText(node.textContent);
      } else {
        this.hyphenateElement(node);
      }
    }
  };

  FinnishHyphenator.prototype.hyphenateElements = function(els) {
    for (var i = 0; i < els.length; i++) {
      this.hyphenateElement(els[i]);
    }
  };

  /* Hyphenates text block */
  FinnishHyphenator.prototype.hyphenateText = function(text) {
    var hyphenated = text;
    var hyphPositions = [];
    var match;

    // rule [1]
    while ((match = this.rule1RegExp.exec(text)) != null) {
      hyphPositions.push(match.index);
    }

    var count = 0;
    for (var i = 0; i < hyphPositions.length; i++) {
      var position = hyphPositions[i] + count * this.hyphMark.length;
      var triedHyphenation = this.addHyphen(hyphenated, position);
      if (triedHyphenation !== false) {
        count++;
        hyphenated = triedHyphenation;
      }
    }
    return hyphenated;
  };

  window.FinnishHyphenator = FinnishHyphenator;

  // Functionality
  (function($, window, document, FinnishHyphenator) {
    var pluginName = 'finnishHyphenator';
    var finnishHyphenator = null;

    function Plugin(element) {
      if (!finnishHyphenator) {
        finnishHyphenator = new FinnishHyphenator();
      }
      this.element = element;
      this._name = pluginName;
      this.init();
    }

    $.extend(Plugin.prototype, {
      init: function() {
        finnishHyphenator.hyphenateElement(this.element);
      },
    });

    $.fn[pluginName] = function(options) {
      this.each(function() {
        if (!$.data(this, 'plugin_' + pluginName)) {
          $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
        }
      });
      return this;
    };

  })(jQuery, window, document, FinnishHyphenator);

  // Init
  $('.woocommerce .products .product.type-product .woocommerce-loop-product__title').finnishHyphenator();
});


// WEBPACK FOOTER //
// ./scripts/main.js